import { NgModule } from '@angular/core';
import { LibSaveIconComponent } from './lib-save-icon.component';

@NgModule({
  declarations: [LibSaveIconComponent],
  imports: [],
  exports: [LibSaveIconComponent],
})
export class LibSaveIconModule {}
